import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {FLIP_CARD_SIDE, IElementFlipCard} from '../../../../incase-domain/elements/flipCard';
import FlipCardElement from './flipCardElement';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';

interface IElementFlipCardComponentProps {
    element: IElementFlipCard;
    device?: DeviceType;
}

export default function ElementFlipCardComponent(props: IElementFlipCardComponentProps): JSX.Element {
    const {element, device = DeviceType.DESKTOP} = props;
    const {t} = useTranslation();

    const [isFlipped, setIsFlipped] = useState(false);

    return (
        <div
            className={`c-flipCardElement ${isFlipped && 'is-flipped'}`}
            onClick={() => (!element.flipCardOnHover ? setIsFlipped(!isFlipped) : '')}
            onMouseEnter={() => element.flipCardOnHover && setIsFlipped(true)}
            onMouseLeave={() => element.flipCardOnHover && setIsFlipped(false)}
        >
            <div
                className={
                    device === DeviceType.DESKTOP ? 'c-flipCardElement__inner' : 'c-flipCardElement__inner c-flipCardElement__inner_mobile'
                }
            >
                <div className="c-flipCardElement__inner_front">
                    {(element as IElementFlipCard).flipCardElement && (element as IElementFlipCard).flipCardElement.FRONT ? (
                        <FlipCardElement
                            element={element.flipCardElement}
                            flipCardSide={FLIP_CARD_SIDE.FRONT}
                            type={element.flipCardElement.FRONT.type}
                            device={device}
                        />
                    ) : (
                        <h3>{t('flipCard.frontSide')}</h3>
                    )}
                </div>
                <div className="c-flipCardElement__inner_back">
                    {(element as IElementFlipCard).flipCardElement && (element as IElementFlipCard).flipCardElement.BACK ? (
                        <FlipCardElement
                            element={element.flipCardElement}
                            flipCardSide={FLIP_CARD_SIDE.BACK}
                            type={element.flipCardElement.BACK.type}
                            device={device}
                        />
                    ) : (
                        <h3>{t('flipCard.backSide')}</h3>
                    )}
                </div>
            </div>
        </div>
    );
}
